import React from 'react';
import './forms.css';

const SmelterForm = () => {
    return (
        <div className="forms">
            <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLSd13OayvtxqRoeP7S73TtaQD80vkNTA2-qeW98MI1YI_PxGeg/viewform?embedded=true"
                width="100%" /* Set the iframe width to 100% */
                height="100%" /* Allow the height to adapt to the container */
                frameBorder="0"
                title="General Delegate Form"
            >
                Loading…
            </iframe>
        </div>
    );
}

export default SmelterForm;
